import { TenantSettings } from '@/types/settings.types';
import { AuthUser } from '@/types/types';

import { AccessOptions } from './use-access';

export function checkAccess(
  settings: TenantSettings | undefined,
  user: AuthUser | undefined | null,
  options: AccessOptions
): boolean {
  const hasModule = options.module ? (settings?.modules?.includes(options.module) ?? false) : true;

  const hasRole = options.roles ? options.roles.some((role) => user?.role.includes(role)) : true;

  const isRestricted = options.restrictedRoles
    ? options.restrictedRoles.some((role) => user?.role.includes(role))
    : false;

  const hasPermission = isRestricted
    ? options.permission
      ? (user?.permissions?.[options.permission] ?? false)
      : false
    : true;

  return hasModule && hasRole && hasPermission;
}
